<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold leading-7 text-gray-900 sm:leading-9 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row items-center">
                        Videos
                    </span>
                </span>
                <span>
                    <button type="button" @click.prevent="handleCreateVideo"
                            class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-600 hover:bg-custom-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                        Ajouter une video
                    </button>
                </span>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <div class="m-4">
                <List
                    :items="videos"
                    :columns="columns"
                    :desc="desc"
                    @dragEnd="handleDragEnd"
                    @editItem="handleEditVideo"
                    @deleteItem="handleDeleteVideo"
                    moveable
                    editable
                    deletable
                />
            </div>
        </div>
    </main>
</template>

<script>
    import Loader from "../../components/partials/loader"
    import PageHeader from "../../components/partials/page-header"
    import List from "../../components/partials/list"

    export default {
        beforeMount() {
            if (!this.domain || this.domain.id !== this.$route.params.domain_id) {
                this.$store.dispatch('domains/getSingle', {id: this.$route.params.domain_id, includes: ['projects', 'settings', 'files', 'videos', 'videos.formats', 'videos.thumb']})
            }
        },
        data() {
            return {
                desc: false
            }
        },
        computed: {
            domain() {
                return this.$store.state.domains.single;
            },
            videos() {
                return this.domain && this.domain.videos ? this.domain.videos.data : [];
            },
            locale() {
                return this.$store.state.config.locale;
            },
            columns() {
                return {
                    id: {},
                }
            }
        },
        methods: {
            handleCreateVideo() {
                this.$store.dispatch('videos/resetSingle');
                this.$store.dispatch('modals/open', 'video-save');
            },
            handleEditVideo(video) {
                this.$store.dispatch('videos/setSingle', video);
                this.$store.dispatch('modals/open', 'video-save');
            },
            handleDeleteVideo(video) {
                this.$store.state.videos.single = video;
                this.$store.dispatch('modals/open', 'video-delete');
            },
            handleDragEnd(videos) {
                this.$store.dispatch('videos/move', { movedFields: videos });
            }
        },
        components: {
            Loader,
            PageHeader,
            List
        }
    }
</script>
